export const zIndex = {
  lower: 10,
  low: 20,
  base: 30,
  high: 40,
  higher: 50,
};
